import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  TextField,
} from "@mui/material";
import api, { baseURL } from "../../utils/api.js";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SAMPLE_REPORT_URL = "/assets/askthesea_sample_report.pdf";

export default function DownloadReportDialog({ open, onClose }) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      setEmail("");
      setError("");
      setSubmitting(false);
    }
  }, [open]);

  const triggerDownload = () => {
    const link = document.createElement("a");
    link.href = SAMPLE_REPORT_URL;
    link.download = "AskTheSea Sample Report.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async () => {
    const trimmed = email.trim();
    if (!EMAIL_PATTERN.test(trimmed)) {
      setError("Please enter a valid email address.");
      return;
    }

    setSubmitting(true);
    setError("");
    try {
      await api.post(`${baseURL}/anonymous/save_users_email`, { email: trimmed });
      triggerDownload();
      onClose();
    } catch (err) {
      console.error("Failed to save email:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Download Sample Report</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1, minWidth: 320 }}>
        <Typography variant="body1">
          Enter your email address to download a sample CMC regulatory intelligence report.
        </Typography>
        <TextField
          label="Email address"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSubmit();
          }}
          error={!!error}
          helperText={error}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Submitting..." : "Download"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
